import { useState } from 'react';
import { P2GButton, P2GGrid, P2GLink, P2GTextField } from '@parcel2go/core-ui';
import { TranslationNamespaces } from '~/lib/constants';
import { useTranslation } from 'react-i18next';
import { TariffCode } from './TariffCode';
import { TariffSelector } from './TariffSelector';
import { TariffSuggestions } from './TariffSuggestions';

interface props {
  value: string;
  onChange: (value: string) => void;
  system: string;
  searchTerm?: string;
  disabled?: boolean;
  required?: boolean;
}

export const TariffCodeField: React.FC<props> = (props) => {
  const { t } = useTranslation(TranslationNamespaces.SMARTSEND);
  const [codeOnLoad, setCodeOnLoad] = useState(!!props.value);

  return (
    <>
      <P2GGrid item xs={12}>
        {codeOnLoad ? (
          <P2GGrid container spacing={1} alignItems="center">
            <P2GGrid item flexShrink={1}>
              <TariffCode code={props.value || ''} selectable={true} />
            </P2GGrid>
            {!props.disabled && (
              <P2GGrid item flexShrink={1}>
                <P2GLink onClick={() => setCodeOnLoad(false)} variant="body2">
                  {t('EDIT_TARIFF_CODE_LINK', { defaultValue: 'Edit Tariff Code' })}
                </P2GLink>
              </P2GGrid>
            )}
          </P2GGrid>
        ) : (
          <P2GTextField
            fullWidth
            showErrorsWhenPristine={true}
            required={props.required}
            disabled={props.disabled}
            value={props.value || ''}
            onChange={(v) => props.onChange(v.currentTarget.value)}
            label={t('TARIFF_CODE_INPUT_LABEL', { defaultValue: 'Tariff Code' })}
            id="TariffCode"
            endAdornment={
              !props.disabled && (
                <TariffSelector
                  title={t('TARIFF_CODE_SELECTOR_SIDEPANEL_TITLE', { defaultValue: 'Tariff Code Selector' })}
                  default="SUGGEST"
                  options={['SUGGEST', 'SEARCH', 'BROWSE']}
                  control={
                    <P2GButton variant="primary">{t('BROWSE_TARIFF_BUTTON', { defaultValue: 'Browse' })}</P2GButton>
                  }
                  searchTerm={props.searchTerm}
                  system={props.system}
                  tariffCode={props.value || ''}
                  canSelect={true}
                  selectCode={(v) => {
                    if (v?.length >= 6) {
                      setCodeOnLoad(true);
                    }
                    props.onChange(v);
                  }}
                />
              )
            }
          />
        )}
      </P2GGrid>
      {!props.disabled && !codeOnLoad && !props.value && (
        <P2GGrid item xs={12}>
          <TariffSuggestions
            title={t('TARIFF_SUGGESTION_TITLE', { defaultValue: 'Suggestion:' })}
            canSelect={true}
            limit={3}
            selectCode={props.onChange}
            tariffSystem={props.system}
            itemDescription={props.searchTerm}
          />
        </P2GGrid>
      )}
    </>
  );
};
